import { Button, Collapse, Space, Spin, Modal, message, Tooltip } from "antd";
import { PlusIcon, EditIcon, TrashIcon } from "../../admin/Icons";
import { RedoOutlined, CopyOutlined } from '@ant-design/icons';
import Overlay from "../Overlay";
import wrap from "../../utils/wrap";
import { usePrefs } from "../../utils/Prefs";
import StyleContent from "./StyleContent";
import { canDeleteRecord, tt_preset_delete, tt_preset_duplicate, tt_preset_edit, tt_preset_reset } from "../../utils/Utils";
import { useState } from "react";


export default function StyleContents(props) {

    const { templates = [], data = {}, changed = false, view = "", setData = () => { } } = props;
    const { texts = [] } = data;
    const [prefs, setPrefs] = usePrefs();

    // Used to temporarily undraw the UI so resetting sets the default values on uncontrolled UI
    const [hide, setHide] = useState(null);


    const default_style = {
        id: 1,
        name: "Unnamed Text",
        text_align: "left",
        font: 0,
        font_size: 14,
        font_style: 1,
        letter_spacing: 0,
        line_height: 120,
        colour: 0,
        padding_x: 0,
        padding_y: 0,
        text_shadow_colour: 0,
        text_shadow_x: 0,
        text_shadow_y: 0,
        text_shadow_blur: 0,
        underline_colour: 0,
        underlined: false,
        border_colour: 0,
        border_size: 0,
        border_radius: 0,
        border_left: 0,
        border_top: 0,
        border_right: 0,
        border_bottom: 0,
        background_colour: 0,
        background_visible: false,
        background_shadow_colour: 0,
        background_shadow_x: 0,
        background_shadow_y: 0,
        background_shadow_blur: 0,
        background_shadow_spread: 0,
        allow_mobile_overrides: false,
        mobile_font_size: 14,
        mobile_line_height: 120,
        mobile_padding_x: 0,
        mobile_padding_y: 0,
        text_transform : "none"

    }

    // Save name and default text object
    const saveNew = (_name, _obj) => {

        _obj.name = _name;
        _obj.id = data.texts.length + 1;
        let _texts = [...data.texts];
        _texts.push(_obj);

        setData({ ...data, "texts": _texts });
        setPrefs({ ...prefs, "changed": true, "content_index": _obj.id });
    }

    // Save a field in a content item (deep object save)
    const save = (_id, _value, _keys = [], _new = false) => {

        let _texts = [...texts];
        let _index = texts.findIndex(item => item.id === _id)
        // instance found
        if (_index > -1) {
            _texts[_index][_keys[0]] = _value
            delete _texts[_index]["send"];
            setPrefs({ ...prefs, "changed": true })
            setData({ ...data, "texts": _texts });
        }
    }

    // Draw header
    const drawHeader = () => {
        return (
            <Overlay width="320px" component={<StyleContent default_style={default_style} saveNew={saveNew} save={save} is_new contents={texts} />}><wrap.tags color="#1890ff"><small>New</small>&nbsp; <PlusIcon />&nbsp;</wrap.tags></Overlay>
        )
    }

    const reset = (e, _id) => {
        e.stopPropagation();
        e.preventDefault();
        Modal.confirm({
            title: "Reset?",
            onOk: () => {
                setHide(_id);
                let _texts = [...data.texts];
                let _f = _texts.findIndex(item => item.id === _id)
                if (_f > -1) {
                    _texts[_f] = { ...default_style, "id": _id, "send": false }
                } else {
                    message.error("There was an error");
                }
                setData({ ...data, "texts": _texts });
                setPrefs({ ...prefs, "changed": true });
                setTimeout(() => {
                    setHide(null)
                }, 100)
            }
        })
    }

    const remove = (e, _id) => {
        e.stopPropagation();
        e.preventDefault();
        Modal.confirm({
            title: "Delete?",
            onOk: () => {
                let _texts = data.texts.filter(item => item.id !== _id);
                setData({ ...data, "texts": _texts });
                setPrefs({ ...prefs, "changed": true });
            }
        })
    }

    const duplicate = (e, _obj) => {
        e.stopPropagation();
        e.preventDefault();
        Modal.confirm({
            title: "Duplicate?",
            onOk: () => {
                _obj.name = _obj.name + " (copy)";
                _obj.id = data.texts.length + 1;
                let _texts = [...data.texts];
                delete _obj.send;
                _texts.push(_obj);
                setData({ ...data, "texts": _texts });
                setPrefs({ ...prefs, "changed": true, "button_index": _obj.id });
            }
        })
    }


    // Draw content item list
    const drawButtons = () => {
        return (
            <div>
                <Collapse accordion onChange={(e) => setPrefs({ ...prefs, "content_index": e })} activeKey={prefs.content_index} className="subpanel" expandIcon={({ isActive }) => {
                    return (isActive) ? "-" : "+"
                }} ghost>
                    {texts.map(item => {

                        if (hide === item.id) {
                            return (<></>)
                        }

                        let name = (item.hasOwnProperty("name")) ? item.name : "";
                        let can_delete = canDeleteRecord(templates, data, item.id, "texts");
                        // let is_reset = false; 
                        // if(item.hasOwnProperty("send") && !item.send){
                        //     is_reset = true; 
                        // }
                        return (
                            <Collapse.Panel header={
                                <div className="float-flex">
                                    <div style={{ "color": "#e77e21", "fontSize": "11px" }}>{name.toUpperCase()}</div>
                                    <Space>
                                        <Tooltip title={tt_preset_duplicate}><Button onClick={(e) => duplicate(e, { ...item })} type="link" icon={<CopyOutlined />} size="small" /></Tooltip>
                                        {(!can_delete && <Tooltip title={tt_preset_reset}><Button onClick={(e) => reset(e, item.id)} type="link" icon={<RedoOutlined />} size="small" /></Tooltip>)}
                                        {(can_delete && <Tooltip title={tt_preset_delete}><Button onClick={(e) => remove(e, item.id)} type="link" icon={<TrashIcon />} size="small" /></Tooltip>)}

                                        <Overlay width="320px" component={<StyleContent default_style={default_style} saveNew={saveNew} save={save} is_edit id={item.id} content={item} contents={texts} />}>
                                            <Tooltip title={tt_preset_edit}><EditIcon /></Tooltip>
                                        </Overlay>
                                    </Space>
                                </div>
                            } key={item.id}>
                                <StyleContent default_style={default_style} saveNew={saveNew} save={save} data={data} content={item} contents={texts} />
                            </Collapse.Panel>
                        )
                    })}
                </Collapse>
            </div>
        )
    }

    switch (view) {
        case "header":
            return drawHeader();
        default:
            return drawButtons();
    }

}

